import api from '../config/api';

export interface Contact {
  id?: number;
  nom: string;
  email: string;
  sujet: string;
  message: string;
  telephone?: string;
  lu?: boolean;
  repondu?: boolean;
  confirmation_sent?: boolean;
  created_at?: string;
  updated_at?: string;
}

export const contactService = {
  create: async (data: Omit<Contact, 'id'>): Promise<{ message: string }> => {
    const response = await api.post('/contact/contacts/', data);
    return response.data;
  },
};

